import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from '../../../_services/dialog.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { PledgePerWinService } from '../../../_services/fundraising/pledgePerWin.service';
import { PledgePerWinTeam } from '../../../_models/fundraising/ppw/PledgePerWinTeam';

@Component({
  selector: 'app-team-management',
  templateUrl: './team-management.component.html',
  styleUrls: ['../../fundraising-management.component.css', './team-create.component.css']
})

export class TeamManagementComponent implements OnInit  {

  loading = false;
  searchText: string;

  public teams:PledgePerWinTeam[] = [];
  public displayItems = [];

  public selectedTeam = 0;

  private bsModalRef: BsModalRef;

  constructor(
    private ppwService: PledgePerWinService,
    private router: Router,
    private viewRef: ViewContainerRef,
    private dialogService: DialogService,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.ppwService.getAllTeams()
      .subscribe(teams => {
        this.teams = teams;
        this.displayItems = [...this.teams]
      });
  }

  public create() {
    this.router.navigate([`/portal/fundraising/ppw/team/create`]);
  }

  edit(objectId: number) {
    this.router.navigate([`/portal/fundraising/ppw/team/edit/`, objectId]);
  }

  public search() {
    this.displayItems = [...this.teams];
    
    if (!this.searchText) {
      return;
    }
    
    let quoteRegex = /[^\s"]+|"([^"]*)"/gi;
    let searchTerms = [];
    let match;

    do {

      match = quoteRegex.exec(this.searchText.toLowerCase());

      if (match != null) {
        searchTerms.push(match[1] ? match[1] : match[0]);
      }

    } while (match != null);


    let filtered = [];

    searchTerms.forEach(s => {
      const f = this.displayItems.filter(d =>
        (d.name ? d.name.toLowerCase().indexOf(s) !== -1 : false) ||
        (d.sport ? d.sport.toLowerCase().indexOf(s) !== -1 : false) ||
        (d.description ? d.description.toLowerCase().indexOf(s) !== -1 : false) ||
        !s);

      f.forEach(y => {
        filtered.push(y);
        this.displayItems.splice(this.displayItems.indexOf(y), 1);
      })
    });

    this.displayItems = filtered;
  }

  formatTime(t: string) {
    const d = new Date(); 

    const hms = t.split(':');
    d.setHours(+hms[0] || 0);
    d.setMinutes(+hms[1] || 0);

    return d;
  }

}
